/* tslint:disable:member-ordering */
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LegacyCheckoutEndpointResponseDto } from '../model/legacyCheckoutEndpointResponseDto';
import { LegacyDynamicPricesRequestDto } from '../model/legacyDynamicPricesRequestDto';
import { LegacyDynamicPricesResponseDto } from '../model/legacyDynamicPricesResponseDto';
import { LegacyProductsInfoResponseDto } from '../model/legacyProductsInfoResponseDto';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  protected basePath;
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Inject(BASE_PATH) basePath: string | string[]
  ) {
    this.basePath = basePath;
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          k =>
            (httpParams = this.addToHttpParamsRecursive(
              httpParams,
              value[k],
              key != null ? `${key}.${k}` : k
            ))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  public apiCorePaymentCoreCartCheckoutInfo(
    shopId?: number,
    startDate?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      responseType: 'text' | 'json' | 'blob';
      headers?: HttpHeaders;
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<LegacyCheckoutEndpointResponseDto> {
    let localVarQueryParameters = new HttpParams();
    if (shopId !== undefined && shopId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>shopId, 'shopId');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'startDate');
    }

    let localVarPath = `/core/cart/checkout-info`;
    return this.httpClient.request<LegacyCheckoutEndpointResponseDto>(
      'get',
      `${this.basePath}${localVarPath}`,
      {
        params: localVarQueryParameters,
        responseType: options?.responseType || ('json' as any),
        observe,
        transferCache: options?.transferCache ?? true,
        reportProgress,
        headers: options?.headers
      }
    );
  }

  public apiCorePaymentDynamicPriceInfo(
    legacyDynamicPricesRequestDto: LegacyDynamicPricesRequestDto,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      responseType: 'text' | 'json' | 'blob';
      headers?: HttpHeaders;
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<LegacyDynamicPricesResponseDto> {
    let localVarPath = `/core/cart/dynamic-price-info`;
    return this.httpClient.request<LegacyDynamicPricesResponseDto>(
      'post',
      `${this.basePath}${localVarPath}`,
      {
        body: legacyDynamicPricesRequestDto,
        responseType: options?.responseType || ('json' as any),
        observe,
        transferCache: options?.transferCache ?? true,
        reportProgress,
        headers: options?.headers
      }
    );
  }

  public apiCorePaymentProductsInformation(
    shopId: number,
    partnerPrefix?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      responseType: 'text' | 'json' | 'blob';
      headers?: HttpHeaders;
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<LegacyProductsInfoResponseDto> {
    let localVarQueryParameters = new HttpParams();
    if (shopId !== undefined && shopId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>shopId, 'shopId');
    }
    if (partnerPrefix !== undefined && partnerPrefix !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>partnerPrefix,
        'partnerPrefix'
      );
    }

    let localVarPath = `/core/cart/products-information`;
    return this.httpClient.request<LegacyProductsInfoResponseDto>('get', `${this.basePath}${localVarPath}`, {
      params: localVarQueryParameters,
      responseType: options?.responseType || ('json' as any),
      observe,
      transferCache: options?.transferCache ?? true,
      reportProgress,
      headers: options?.headers
    });
  }
}
